// extracted by mini-css-extract-plugin
export default {"root":"RigthWrongCount_root__+7wqg"};